import React from 'react';

export function OnboardingSkeleton({ numInputs = 3, showCheckbox = false }) {
  return (
    <div className="p-6 w-full max-w-2xl mx-auto animate-pulse">
      <div className="space-y-6">
        {/* Skeleton for Title and Subtitle */}
        <div>
          <div className="h-8 w-3/4 bg-[var(--q3-surface-dim)] rounded-md mb-2"></div>
          <div className="h-5 w-1/2 bg-[var(--q3-surface-dim)] rounded-md"></div>
        </div>

        {/* Skeleton for Form Fields */}
        <div className="space-y-4">
          {Array.from({ length: numInputs }).map((_, index) => (
            <div key={index} className="h-[40px] w-full bg-[var(--q3-surface-dim)] rounded-full"></div>
          ))}

          {showCheckbox && (
            <div className="flex items-center space-x-2">
              <div className="h-5 w-5 bg-[var(--q3-surface-dim)] rounded border-[var(--q3-stroke-normal)]"></div>
              <div className="h-4 w-48 bg-[var(--q3-surface-dim)] rounded-md"></div>
            </div>
          )}
        </div>

        {/* Skeleton for Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 pt-4">
          <div className="w-full sm:w-auto px-8 h-[40px] bg-[var(--q3-surface-dim)] rounded-full"></div>
          <div className="w-full sm:flex-1 h-[40px] bg-[var(--q3-surface-dim)] rounded-full"></div>
        </div>
      </div>
    </div>
  );
}
